module.exports = __webpack_public_path__ + "static/img/3.e074e93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/3.png
// module id = AGx/
// module chunks = 0